module.exports = __webpack_public_path__ + "img/01.1c768d9f.png";